import {ApolloClient} from 'apollo-client'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {HttpLink} from 'apollo-link-http'
// import {ApolloLink} from 'apollo-link'
// import {WebSocketLink} from "apollo-link-ws";
// import {getOperationAST} from "graphql";

import fetch from 'unfetch';

const baseUrl = process.env.VUE_APP_GQL_URL
  || `${window.location.protocol}//${window.location.host}`; // 后台地址
console.log('gqlPath:', baseUrl);

const apiLink = new HttpLink({
  uri: `${baseUrl}/graphql`,
  fetch: fetch
});

/*
// 含订阅
const link = ApolloLink.split(
  operation => {
    const operationAST = getOperationAST(operation.query, operation.operationName);
    return !!operationAST && operationAST.operation === "subscription";
  },
  new WebSocketLink({
    uri: `ws://${baseUrl}`,
    options: {
      reconnect: true,
    },
  }),
  new HttpLink({uri: `${location.protocol}//${baseUrl}`}),
);
*/

// Create the apollo client
export default new ApolloClient({
  link: apiLink,
  cache: new InMemoryCache(), // Cache implementation
  connectToDevTools: true,
});
